import React, { useState, useEffect, useRef } from "react";
import cx from "classnames";
import * as Search from "@elevio/kb-kit/lib/components/search";
import { useLanguages } from "@elevio/kb-kit/lib/hooks";
import { bannerUrl } from '../pages/home';
import { Logo } from "./Logo";
import LoginLogout from "./LoginLogout";
import LanguagePicker from "./LanguagePicker";
import Validator from "../utils/Validators";
import { getSubmissions } from "../requests/user-submission";
import MetaTags from 'react-meta-tags';
function Header({ children, className, hideSearch, breadcrumbs }) {
    const [displaySearchBar, setDisplaySearchBar] = useState(false);
    const [displayMobileMenu, setDisplayMobileMenu] = useState(false);
    const [displayRequestField, setDisplayRequestField] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const requestInput = useRef(document.createElement('input'));
    const requestInputMobile = useRef(document.createElement('input'));
    const requestSubmissionContainer = useRef(document.createElement('div'));
    const requestSubmissionContainerMobile = useRef(document.createElement('div'));
    const { supportedLanguages, selectedLanguage, setCurrentLanguageId, } = useLanguages();
    useEffect(() => {
        const script = document.createElement("script");
        if (isMobile()) {
            script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async = true;
            document.body.appendChild(script);
            const script2 = document.createElement("script");
            script2.innerHTML = ` function googleTranslateElementInit() {
        new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element_mobile');
       } `;
            document.body.appendChild(script2);
            script.async = true;
        }
        else {
            script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async = true;
            const script3 = document.createElement("script");
            script3.innerHTML = ` function googleTranslateElementInit() {
      new google.translate.TranslateElement({
        pageLanguage: 'en',
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
        autoDisplay: false
      }, 'google_translate_element'); } `;
            document.body.appendChild(script3);
        }
        document.body.appendChild(script);
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);
    const isTablet = () => {
        return navigator.userAgent.match(/iPad/i) != null;
    };
    const isMobile = () => {
        return (navigator.userAgent.match(/Android/i) != null ||
            navigator.userAgent.match(/iPhone/i) != null);
    };
    const isDesktop = () => window.screen.width > 1024;
    const isIE = () => {
        return false || !!document.documentMode;
    };
    const handleClick = e => {
        if (isMobile() && requestSubmissionContainerMobile.current && !requestSubmissionContainerMobile.current.contains(e.target)) {
            setErrorMessage('');
            setDisplayRequestField(false);
            setResponseMessage('');
        }
        else if (!isMobile() && requestSubmissionContainer.current && !requestSubmissionContainer.current.contains(e.target)) {
            setErrorMessage('');
            setDisplayRequestField(false);
            setResponseMessage('');
        }
    };
    const toggleRequestField = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (displayRequestField) {
            setErrorMessage('');
        }
        setDisplayRequestField(!displayRequestField);
    };
    const onRequestSubmissionClickMobile = () => {
        const contactInfo = requestInputMobile.current.value;
        setErrorMessage('');
        const validator = new Validator();
        if (contactInfo && (validator.isEmail(contactInfo) || validator.isPhone(contactInfo))) {
            const token = process.env.CRM_TOKEN || '2ysz1dvfru';
            setLoading(true);
            getSubmissions(token, contactInfo).then(result => {
                requestInput.current.value = '';
                setResponseMessage(result.message);
                setDisplayRequestField(false);
            }).catch((error) => {
                console.log(error);
            }).finally(() => setLoading(false));
        }
        else {
            let errorMessage = 'Incorrect email or mobile number format';
            if (!contactInfo || contactInfo && !contactInfo.trim()) {
                errorMessage = 'The email or mobile number is required.';
            }
            setErrorMessage(errorMessage);
        }
    };
    const onRequestSubmissionClick = () => {
        const contactInfo = requestInput.current.value;
        setErrorMessage('');
        const validator = new Validator();
        if (contactInfo && (validator.isEmail(contactInfo) || validator.isPhone(contactInfo))) {
            const token = process.env.CRM_TOKEN || '2ysz1dvfru';
            setLoading(true);
            getSubmissions(token, contactInfo).then(result => {
                requestInput.current.value = '';
                setResponseMessage(result.message);
                setDisplayRequestField(false);
            }).catch((error) => {
                console.log(error);
            }).finally(() => setLoading(false));
        }
        else {
            let errorMessage = 'Incorrect email or mobile number format';
            if (!contactInfo || contactInfo && !contactInfo.trim()) {
                errorMessage = 'The email or mobile number is required.';
            }
            setErrorMessage(errorMessage);
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            onRequestSubmissionClick();
        }
    };
    const handleKeyDownMobile = (event) => {
        if (event.key === 'Enter') {
            onRequestSubmissionClickMobile();
        }
    };
    return (<div id="wrapper" className="wrapper">
    <MetaTags>
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"/>
    </MetaTags>

    <header className={cx("header", "header-bg-color", "header-text-color", className)} data-testid="header">
      <div id="header-wrapper" className="header-wrapper">
        <nav className="nav" aria-label="navigation">
          <div id="nav-wrapper" className="nav-wrapper">
            <div id="nav-details" className="nav-details">

              <Logo />
            </div>

            <div id="nav-desktop-menu" className="nav-desktop-menu">
              <div id="request-submission-container" className="request-submission-container" ref={requestSubmissionContainer}>
                <a className="nav-desktop-menu-link" href="https://agency.comcate.com/private-submission/listing?crm_token=5oe00emr75q&auth_enabled=true&logout_redirect_url=https%3A%2F%2Fbozeman.comcate.com%2Fen" target="_blank" rel="noopener noreferrer">
                  <div id="request-link" className="request-link">
                    <svg className="request-link-logo" height='100px' width='100px' fill="#fff" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" xmlSpace="preserve"><g><path d="M4.3,68.6l18.3,2.9V28.6L4.3,31.4V68.6z M8.7,35.2l9.6-1.5v32.7l-9.6-1.5V35.2z M77.8,28.6v42.9l17.9-2.9   V31.4L77.8,28.6z M91.3,64.8l-9.2,1.5V33.7l9.2,1.5V64.8z M26.4,83.5h47.3V16.5H26.4V83.5z M30.7,20.9h38.6v58.2H30.7V20.9z"></path></g></svg>
                    <span className="request-link-text">
                      <div id="View-Your-Submissions">Login to Account</div>
                    </span>
                  </div>
                </a>
                {/* Email/phone input logic commented out - replaced with direct link above */}
                {/* {displayRequestField && (
          <div id="request-field-dropdown" className="request-field-dropdown">
            <div id="request-input" className="request-input">
              <input
                placeholder="Enter your email or mobile number"
                ref={requestInput}
                onKeyDown={handleKeyDown}
              />
              {errorMessage && (
                <div id='error-message'>{errorMessage}</div>
              )}
            </div>
            <div id="request-action" className="request-action">
              <button disabled={loading} onClick={onRequestSubmissionClick}>OK</button>
            </div>
          </div>
        )}
        {responseMessage && (
          <div id="request-field-dropdown response-message-container" className="request-field-dropdown response-message-container">
            <div id="response-message" className="response-message">
              <span onClick={() => setResponseMessage('')}>x</span>
              <div id={responseMessage}>{responseMessage}</div>
            </div>
          </div>
        )} */}
              </div>
              <div id="google_translate_element"></div>
              <LoginLogout className="nav-desktop-menu-link"/>
              {supportedLanguages.length > 1 && (<LanguagePicker selectedLanguageId={selectedLanguage.id} setCurrentLanguageId={setCurrentLanguageId} supportedLanguages={supportedLanguages}/>)}
            </div>
          </div>
        </nav>

          <div id="mobile-menu" className="mobile-menu">
            <div id="mobile-menu-wrapper" className="mobile-menu-wrapper">
              {/* <a className="mobile-menu-link" href="#">
        <Trans i18nKey="external-link">Our Site</Trans>
      </a> */}
              <div id="request-submission-container" className="request-submission-container" ref={requestSubmissionContainerMobile}>
                <a className="nav-desktop-menu-link mobile-menu-link" href="https://agency.comcate.com/private-submission/listing?crm_token=5oe00emr75q&auth_enabled=true&logout_redirect_url=https%3A%2F%2Fbozeman.comcate.com%2Fen" target="_blank" rel="noopener noreferrer">
                  <div id="request-link-1" className="request-link">
                    <svg className="request-link-logo" height='100px' width='100px' fill="#fff" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" xmlSpace="preserve"><g><path d="M4.3,68.6l18.3,2.9V28.6L4.3,31.4V68.6z M8.7,35.2l9.6-1.5v32.7l-9.6-1.5V35.2z M77.8,28.6v42.9l17.9-2.9   V31.4L77.8,28.6z M91.3,64.8l-9.2,1.5V33.7l9.2,1.5V64.8z M26.4,83.5h47.3V16.5H26.4V83.5z M30.7,20.9h38.6v58.2H30.7V20.9z"></path></g></svg>
                    <span className="request-link-text">
                      <div id="View-Your-Submissions-1">Login to Account</div>
                    </span>
                  </div>
                </a>
                {/* Email/phone input logic commented out - replaced with direct link above */}
                {/* {displayRequestField && (
          <div id="request-field-dropdown-1" className="request-field-dropdown">
            <div id="request-input-1" className="request-input">
              <input
                placeholder="Enter your email or mobile number"
                ref={requestInputMobile}
                onKeyDown={handleKeyDownMobile}
              />
              {errorMessage && (
                <div id='error-message-1' className='error-message'>{errorMessage}</div>
              )}
            </div>
            <div id="request-action-1" className="request-action">
              <button disabled={loading} onClick={onRequestSubmissionClickMobile}>OK</button>
            </div>
          </div>
        )}
        {responseMessage && (
          <div id="request-field-dropdown response-message-container-1" className="request-field-dropdown response-message-container">
            <div id="response-message-1" className="response-message">
              <span onClick={() => setResponseMessage('')}>x</span>
              <div id="responseMessage-1">{responseMessage}</div>
            </div>
          </div>
        )} */}
                <div id="google-translate-button-1" className="google-translate-button">
                  <div id="google_translate_element_mobile"></div>
                </div>
              </div>
              <LoginLogout className="mobile-menu-link"/>
              {supportedLanguages.length > 1 && (<LanguagePicker selectedLanguageId={selectedLanguage.id} setCurrentLanguageId={setCurrentLanguageId} supportedLanguages={supportedLanguages}/>)}
            </div>
          </div>



        {displaySearchBar && !hideSearch && (<div id="mobile-search" className="mobile-search">
            <div id="mobile-search-wrapper" className="mobile-search-wrapper">
              <Search.Input className="mobile-search-input"/>
            </div>
          </div>)}

        {children && (<div id="hero" className="hero" style={{ backgroundImage: `url(${bannerUrl})` }}>
            <div className="hero-wrapper" id="hero-wrapper">{children}</div>
          </div>)}
        {breadcrumbs}
      </div>
    </header>
  </div>);
}
export default Header;
